export default {"name":"Light","dark":false};